// Public one-line summary of an agent brief. The full SOUL/brief is the
// owner's private instruction set; cards and lists show only this line.
export function roleSummary(role, max = 110) {
  if (!role) return '';
  const text = String(role)
    .replace(/```[\s\S]*?```/g, ' ')
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l && !/^#{1,6}\s/.test(l) && !/^[-*]\s*[A-Z][A-Z /&]+:/.test(l))
    .join(' ')
    .replace(/[*_`>#]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  let first = (text.match(/^.*?[.!?](?=\s|$)/) || [text])[0].trim();
  first = first.replace(/^You are (an?|the)\s+/i, (_m, art) => `${art[0].toUpperCase()}${art.slice(1).toLowerCase()} `);
  return first.length > max ? `${first.slice(0, max - 1).trimEnd()}…` : first;
}
